<template>
  <div
    class="wrapper"
    :class="{ hidingSideBar, minimized, 'nav-open': $sidebar.showSidebar }"
  >
    <side-bar class="side-bar" style="overflow-x: hidden" v-model="minimized">
      <mobile-menu slot="content"></mobile-menu>

      <sidebar-link v-for="link in availableLinks" :key="link.to" :to="link.to">
        <span
          class="icon-wrapper d-flex justify-content-center align-items-center"
        >
          <svg
            v-if="link.str === 'Klantoverzicht'"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1"
              d="M16 8v8m-4-5v5m-4-2v2m-2 4h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
            />
          </svg>
          <svg
            v-else-if="link.str === 'Winkel'"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1"
              d="M15 15l-2 5L9 9l11 4-5 2zm0 0l5 5M7.188 2.239l.777 2.897M5.136 7.965l-2.898-.777M13.95 4.05l-2.122 2.122m-5.657 5.656l-2.12 2.122"
            />
          </svg>
          <svg
            v-else-if="link.str === 'Marketing'"
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 600 600"
          >
            <g
              transform="matrix(42.857142857142854,0,0,42.857142857142854,0,0)"
            >
              <g>
                <path
                  d="M12.84,12.07,1.17,8A1,1,0,0,1,.5,7.09V6a1,1,0,0,1,.67-.94L12.84,1a.5.5,0,0,1,.66.47V11.6A.5.5,0,0,1,12.84,12.07Z"
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
                <path
                  d="M8.48,10.57A2.75,2.75,0,0,1,3,10.25V8.66"
                  fill="none"
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                ></path>
              </g>
            </g>
          </svg>
          <svg
            v-else-if="link.str === 'Accounts'"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1"
              d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
            />
          </svg>
          <svg v-else-if="link.str === 'Synoniemen'" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor" width="18" height="18">
            <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 21l5.25-11.25L21 21m-9-3h7.5M3 5.621a48.474 48.474 0 016-.371m0 0c1.12 0 2.233.038 3.334.114M9 5.25V3m3.334 2.364C11.176 10.658 7.69 15.08 3 17.502m9.334-12.138c.896.061 1.785.147 2.666.257m-4.589 8.495a18.023 18.023 0 01-3.827-5.802" />
          </svg>
          <svg
            v-else-if="link.str === 'Editor Packages'"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 14 14"
            height="14"
            width="14"
          >
            <path
              d="M4.09,1.19a2,2,0,0,1,.6,1.33L6.52.7a.67.67,0,0,1,1,0L9,2.24a2.18,2.18,0,0,0-.57.4,2.06,2.06,0,0,0,2.91,2.91,2.18,2.18,0,0,0,.4-.57L13.3,6.52a.67.67,0,0,1,0,1L11.48,9.31a2.05,2.05,0,1,1-2.17,2.17L7.48,13.3a.67.67,0,0,1-1,0L5,11.76a2.18,2.18,0,0,0,.57-.4A2.06,2.06,0,0,0,2.64,8.45a2.18,2.18,0,0,0-.4.57L.7,7.48a.67.67,0,0,1,0-1L2.52,4.69a2,2,0,0,1-1.33-.6,2.05,2.05,0,0,1,2.9-2.9Z"
              fill="none"
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
          </svg>
          <svg
            v-else-if="link.str === 'Categorieën'"
            width="14"
            height="14"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 48 48"
          >
            <g
              transform="matrix(3.4285714285714284,0,0,3.4285714285714284,0,0)"
            >
              <g>
                <path
                  d="M13.28,9.39,9.39,13.28a.75.75,0,0,1-1.06,0L.61,5.56A.36.36,0,0,1,.5,5.27l.59-3.83a.37.37,0,0,1,.35-.35L5.27.5a.36.36,0,0,1,.29.11l7.72,7.72A.75.75,0,0,1,13.28,9.39Z"
                  style="
                    fill: none;
                    stroke: currentColor;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                  "
                ></path>
                <circle
                  cx="4.11"
                  cy="4.11"
                  r="0.5"
                  style="
                    fill: none;
                    stroke: currentColor;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                  "
                ></circle>
              </g>
            </g>
          </svg>
          <svg v-else-if="link.str === 'Catalogus'" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16px"
              height="16px" viewBox="0 0 14 14" version="1.1">
              <g id="surface1">
                  <path style=" stroke:none;fill-rule:nonzero;fill:rgb(255,255,255);fill-opacity:1;"
                      d="M 9.976562 11.964844 C 10.1875 11.964844 10.363281 11.792969 10.363281 11.578125 L 10.363281 10.808594 L 11.519531 10.808594 L 11.519531 11.578125 C 11.519531 12.429688 10.828125 13.121094 9.976562 13.121094 L 3.8125 13.121094 C 2.960938 13.121094 2.273438 12.429688 2.273438 11.578125 L 2.273438 10.808594 L 3.429688 10.808594 L 3.429688 11.578125 C 3.429688 11.792969 3.601562 11.964844 3.8125 11.964844 Z M 8.4375 4.644531 C 8.011719 4.644531 7.664062 4.300781 7.664062 3.875 L 7.664062 1.949219 L 3.8125 1.949219 C 3.601562 1.949219 3.429688 2.121094 3.429688 2.332031 L 3.429688 5.414062 L 2.273438 5.414062 L 2.273438 2.332031 C 2.273438 1.480469 2.960938 0.792969 3.8125 0.792969 L 7.796875 0.792969 C 8.207031 0.792969 8.597656 0.953125 8.886719 1.242188 L 11.066406 3.425781 C 11.355469 3.714844 11.519531 4.101562 11.519531 4.511719 L 11.519531 5.414062 L 10.363281 5.414062 L 10.363281 4.644531 Z M 4.390625 6.1875 C 5.136719 6.1875 5.738281 6.789062 5.738281 7.535156 C 5.738281 8.277344 5.136719 8.882812 4.390625 8.882812 L 4.199219 8.882812 L 4.199219 9.652344 C 4.199219 9.863281 4.027344 10.039062 3.8125 10.039062 C 3.601562 10.039062 3.429688 9.863281 3.429688 9.652344 L 3.429688 6.570312 C 3.429688 6.359375 3.601562 6.1875 3.8125 6.1875 Z M 4.96875 7.535156 C 4.96875 7.214844 4.710938 6.957031 4.390625 6.957031 L 4.199219 6.957031 L 4.199219 8.113281 L 4.390625 8.113281 C 4.710938 8.113281 4.96875 7.855469 4.96875 7.535156 Z M 6.125 6.570312 C 6.125 6.359375 6.296875 6.1875 6.511719 6.1875 L 7.089844 6.1875 C 7.726562 6.1875 8.242188 6.703125 8.242188 7.339844 L 8.242188 8.882812 C 8.242188 9.519531 7.726562 10.039062 7.089844 10.039062 L 6.511719 10.039062 C 6.296875 10.039062 6.125 9.863281 6.125 9.652344 Z M 6.894531 9.269531 L 7.089844 9.269531 C 7.300781 9.269531 7.472656 9.09375 7.472656 8.882812 L 7.472656 7.339844 C 7.472656 7.128906 7.300781 6.957031 7.089844 6.957031 L 6.894531 6.957031 Z M 10.363281 6.1875 C 10.574219 6.1875 10.746094 6.359375 10.746094 6.570312 C 10.746094 6.78125 10.574219 6.957031 10.363281 6.957031 L 9.59375 6.957031 L 9.59375 7.726562 L 10.363281 7.726562 C 10.574219 7.726562 10.746094 7.898438 10.746094 8.113281 C 10.746094 8.324219 10.574219 8.496094 10.363281 8.496094 L 9.59375 8.496094 L 9.59375 9.652344 C 9.59375 9.863281 9.417969 10.039062 9.207031 10.039062 C 8.996094 10.039062 8.820312 9.863281 8.820312 9.652344 L 8.820312 6.570312 C 8.820312 6.359375 8.996094 6.1875 9.207031 6.1875 Z M 10.363281 6.1875 " />
              </g>
          </svg>
          <svg
            v-else-if="link.str === 'Alle producten'"
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 48 48"
          >
            <g
              transform="matrix(3.4285714285714284,0,0,3.4285714285714284,0,0)"
            >
              <g>
                <path
                  stroke-width="1"
                  d="M1.5,8.5V13a.5.5,0,0,0,.5.5H12a.5.5,0,0,0,.5-.5V8.5"
                  style="
                    fill: none;
                    stroke: currentColor;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                  "
                ></path>
                <line
                  stroke-width="1"
                  x1="8"
                  y1="8.5"
                  x2="8"
                  y2="13.5"
                  style="
                    fill: none;
                    stroke: currentColor;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                  "
                ></line>
                <line
                  stroke-width="1"
                  x1="1.5"
                  y1="10"
                  x2="8"
                  y2="10"
                  style="
                    fill: none;
                    stroke: currentColor;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                  "
                ></line>
                <polygon
                  stroke-width="1"
                  points="0.5 4 2 0.5 12 0.5 13.5 4 0.5 4"
                  style="
                    fill: none;
                    stroke: currentColor;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                  "
                ></polygon>
                <path
                  stroke-width="1"
                  d="M4.75,4V5a2,2,0,0,1-2,2H2.47a2,2,0,0,1-2-2V4"
                  style="
                    fill: none;
                    stroke: currentColor;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                  "
                ></path>
                <path
                  stroke-width="1"
                  d="M9.25,4V5a2,2,0,0,1-2,2h-.5a2,2,0,0,1-2-2V4"
                  style="
                    fill: none;
                    stroke: currentColor;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                  "
                ></path>
                <path
                  stroke-width="1"
                  d="M13.5,4V5a2,2,0,0,1-2,2h-.25a2,2,0,0,1-2-2V4"
                  style="
                    fill: none;
                    stroke: currentColor;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                  "
                ></path>
              </g>
            </g>
          </svg>
          <svg
            v-else-if="link.str === 'Kortingen'"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1"
              d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"
            />
          </svg>
          <svg v-else-if="link.str === 'Audit pagina'" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor" width="20" height="20">
            <path stroke-linecap="round" stroke-linejoin="round" d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z" />
            <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
          </svg>
          <svg
            v-else-if="link.str === 'Merken'"
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 48 48"
          >
            <g
              transform="matrix(3.4285714285714284,0,0,3.4285714285714284,0,0)"
            >
              <g>
                <path
                  d="M13.25,9.36,9.36,13.25a.75.75,0,0,1-1.06,0L1.79,6.74a.36.36,0,0,1-.11-.29l.59-3.84a.37.37,0,0,1,.34-.34l3.84-.59a.36.36,0,0,1,.29.11L13.25,8.3A.75.75,0,0,1,13.25,9.36Z"
                  style="
                    fill: none;
                    stroke: currentColor;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                  "
                ></path>
                <line
                  x1="4.03"
                  y1="4.03"
                  x2="0.53"
                  y2="0.53"
                  style="
                    fill: none;
                    stroke: currentColor;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                  "
                ></line>
              </g>
            </g>
          </svg>

          <svg
            v-else-if="link.str === 'Attributen'"
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 48 48"
          >
            <g
              transform="matrix(3.4285714285714284,0,0,3.4285714285714284,0,0)"
            >
              <g>
                <path
                  d="M13.25,9.36,9.36,13.25a.75.75,0,0,1-1.06,0L1.79,6.74a.36.36,0,0,1-.11-.29l.59-3.84a.37.37,0,0,1,.34-.34l3.84-.59a.36.36,0,0,1,.29.11L13.25,8.3A.75.75,0,0,1,13.25,9.36Z"
                  style="
                    fill: none;
                    stroke: currentColor;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                  "
                ></path>
                <line
                  x1="4.03"
                  y1="4.03"
                  x2="0.53"
                  y2="0.53"
                  style="
                    fill: none;
                    stroke: currentColor;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                  "
                ></line>
              </g>
            </g>
          </svg>

          <svg v-else-if="link.str === 'Orderpicken'" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.2" stroke="currentColor" width="19" height="19">
            <path stroke-linecap="round" stroke-linejoin="round" d="M11.35 3.836c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m8.9-4.414c.376.023.75.05 1.124.08 1.131.094 1.976 1.057 1.976 2.192V16.5A2.25 2.25 0 0118 18.75h-2.25m-7.5-10.5H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V18.75m-7.5-10.5h6.375c.621 0 1.125.504 1.125 1.125v9.375m-8.25-3l1.5 1.5 3-3.75" />
          </svg>

          <svg
            v-else-if="link.str === 'Groothandel bestellingen'"
            width="14"
            height="14"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 14 14"
          >
            <g>
              <line
                x1="7"
                y1="0.5"
                x2="7"
                y2="4.5"
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></line>
              <line
                x1="8.5"
                y1="11"
                x2="11"
                y2="11"
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></line>
              <path
                d="M.5,4.5h13a0,0,0,0,1,0,0v8a1,1,0,0,1-1,1H1.5a1,1,0,0,1-1-1v-8A0,0,0,0,1,.5,4.5Z"
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></path>
              <path
                d="M.5,4.5,2,1.61A2,2,0,0,1,3.74.5h6.52a2,2,0,0,1,1.79,1.11L13.5,4.5"
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
              ></path>
            </g>
          </svg>
          <svg
            v-else-if="link.str === 'Leveranciers' || link.str === 'Product Settings' || link.str === 'Supplier Orders'"
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 48 48"
          >
            <g
              transform="matrix(3.4285714285714284,0,0,3.4285714285714284,0,0)"
            >
              <g>
                <path
                  d="M.5,4.5h13a0,0,0,0,1,0,0V13a.5.5,0,0,1-.5.5H1A.5.5,0,0,1,.5,13V4.5A0,0,0,0,1,.5,4.5Z"
                  style="
                    fill: none;
                    stroke: currentColor;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                  "
                ></path>
                <path
                  d="M.5,4.5h0a4,4,0,0,1,4-4h5a4,4,0,0,1,4,4h0"
                  style="
                    fill: none;
                    stroke: currentColor;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                  "
                ></path>
                <path
                  d="M11,13.5V8a.5.5,0,0,0-.5-.5h-7A.5.5,0,0,0,3,8v5.5"
                  style="
                    fill: none;
                    stroke: currentColor;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                  "
                ></path>
                <line
                  x1="3"
                  y1="9.5"
                  x2="11"
                  y2="9.5"
                  style="
                    fill: none;
                    stroke: currentColor;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                  "
                ></line>
                <line
                  x1="3"
                  y1="11.5"
                  x2="11"
                  y2="11.5"
                  style="
                    fill: none;
                    stroke: currentColor;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                  "
                ></line>
              </g>
            </g>
          </svg>
          <svg
            v-else-if="link.str === 'Productgroep'"
            class="group"
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              d="M5 3a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2V5a2 2 0 00-2-2H5zM5 11a2 2 0 00-2 2v2a2 2 0 002 2h2a2 2 0 002-2v-2a2 2 0 00-2-2H5zM11 5a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V5zM11 13a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
            />
          </svg>
          <svg
            v-else-if="link.str === 'Website Producten'"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1"
              d="M4 7v10c0 2.21 3.582 4 8 4s8-1.79 8-4V7M4 7c0 2.21 3.582 4 8 4s8-1.79 8-4M4 7c0-2.21 3.582-4 8-4s8 1.79 8 4m0 5c0 2.21-3.582 4-8 4s-8-1.79-8-4"
            />
          </svg>
          <svg
            v-else-if="link.str === 'Bestellingen'"
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              d="M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z"
            />
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1"
              d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0"
            />
          </svg>
          <svg
            v-else-if="link.str === 'Besteladvies'"
            width="14"
            height="14"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 48 48"
          >
            <g
              transform="matrix(3.4285714285714284,0,0,3.4285714285714284,0,0)"
            >
              <g>
                <path
                  d="M4.5,12.5l-4,1,1-3v-9a1,1,0,0,1,1-1h10a1,1,0,0,1,1,1v10a1,1,0,0,1-1,1Z"
                  style="
                    fill: none;
                    stroke: currentColor;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                  "
                ></path>
                <line
                  x1="7.5"
                  y1="3"
                  x2="7.5"
                  y2="6"
                  style="
                    fill: none;
                    stroke: currentColor;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                  "
                ></line>
                <circle
                  cx="7.5"
                  cy="9"
                  r="0.5"
                  style="
                    fill: none;
                    stroke: currentColor;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                  "
                ></circle>
              </g>
            </g>
          </svg>
          <svg
            v-else-if="link.str === 'Aanvulling'"
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 48 48"
          >
            <g
              transform="matrix(3.4285714285714284,0,0,3.4285714285714284,0,0)"
            >
              <g>
                <rect
                  x="0.5"
                  y="0.5"
                  width="13"
                  height="13"
                  rx="3"
                  style="
                    fill: none;
                    stroke: currentColor;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                  "
                ></rect>
                <polyline
                  points="4 7 7 10.5 10 7"
                  style="
                    fill: none;
                    stroke: currentColor;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                  "
                ></polyline>
                <line
                  x1="7"
                  y1="10.5"
                  x2="7"
                  y2="3.5"
                  style="
                    fill: none;
                    stroke: currentColor;
                    stroke-linecap: round;
                    stroke-linejoin: round;
                  "
                ></line>
              </g>
            </g>
          </svg>
          <svg
            v-else-if="link.str === 'Winkel Voorraad'"
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            fill="currentColor"
            viewBox="0 0 16 16">
            <path d="M8.186 1.113a.5.5 0 0 0-.372 0L1.846 3.5l2.404.961L10.404 2l-2.218-.887zm3.564 1.426L5.596 5 8 5.961 14.154 3.5l-2.404-.961zm3.25 1.7-6.5 2.6v7.922l6.5-2.6V4.24zM7.5 14.762V6.838L1 4.239v7.923l6.5 2.6zM7.443.184a1.5 1.5 0 0 1 1.114 0l7.129 2.852A.5.5 0 0 1 16 3.5v8.662a1 1 0 0 1-.629.928l-7.185 2.874a.5.5 0 0 1-.372 0L.63 13.09a1 1 0 0 1-.63-.928V3.5a.5.5 0 0 1 .314-.464L7.443.184z"/>
          </svg>
        </span>

        <transition @enter="enter" @leave="leave">
          <p v-if="!minimized">{{ link.str }}</p>
        </transition>
      </sidebar-link>
    </side-bar>

    <top-navbar v-model="hidingSideBar"></top-navbar>

    <div class="main-panel d-flex flex-column">
      <dashboard-content @click="toggleSidebar" />
    </div>
  </div>
</template>
<style lang="scss">
</style>
<script>
import TopNavbar from "./TopNavbar.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./MobileMenu.vue";

import { mapState } from "vuex";

import { getAvailableSitesByRole, links } from "src/utils/userRoleSite.js";
import transitionFunctionConstructor from "../mixins/transitionFunctionConstructor";

export default {
  mixins: [transitionFunctionConstructor("enter", "leave", "width")],
  components: {
    TopNavbar,
    DashboardContent,
    MobileMenu,
  },
  data() {
    return {
      hidingSideBar: false,
      sidebarLinks: links,
      minimized: false,
    };
  },
  created() {
    this.$checkAuthentication();
    this.cacheMainEndpoints();
    localStorage.setItem("last-admin-page", this.currentPath)

    const minimized = JSON.parse(
      localStorage.getItem("is_sidebar_minimized") || "false"
    );
    if (minimized) this.minimized = minimized;
  },
  methods: {
    async cacheMainEndpoints() {
      try {
        await this.axios.get(`/drop/products`);
      } catch (err) {
        await this.axios.post(`/drop/login`, {
          email: "contact@aegal.nl",
          password: "#4tfu5!hM^d4^T%",
        });
      }

      const endpoints = [
        {
          endpoint: "/api/products",
          params: {
            params: { page_size: 50, page: 1, sort: "name", sort_type: "asc" },
          },
        },
        {
          endpoint: "/api/websites",
          params: { params: { page_size: 30, page: 1 } },
        },
        {
          endpoint: "/api/wholesale/customers",
          params: { params: { page_size: 50, page: 1 } },
        },
        {
          endpoint: "/api/discounts",
          params: { params: { page_size: 20, page: 1 } },
        },
        {
          endpoint: "/api/accounts",
          params: { params: { page_size: 20, page: 1 } },
        },
        {
          endpoint: "/api/brands",
          params: { params: { page_size: 20, page: 1 } },
        },
        // {
        //   endpoint: "/api/colors",
        //   params: { params: { page_size: 15, page: 1 } },
        // },
        {
          endpoint: "/api/suppliers",
          params: { params: { page_size: 20, page: 1 } },
        },
        {
          endpoint: "/api/categories",
          params: { params: { page_size: 20, page: 1, format: "tree" } },
        },
        { endpoint: "/api/orders", params: { params: {} } },
        {
          endpoint: "/drop/products",
          params: { params: { page_size: 30, page: 1 } },
        },
        { endpoint: "/drop/products/order" },
        { endpoint: "/drop/products/settings" },
        { endpoint: "/drop/settings" },
      ];

      endpoints.forEach((param) =>
        this.$store.dispatch("keepTrackOfEndpoint", param)
      );
    },

    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
  },
  computed: {
    ...mapState({
      userRole: (state) => state.user && state.user.role,
    }),

    currentPath() {
      return this.$route.path
    },
    availableLinks() {
      const links = this.roleLinks || [];

      return links.length
        ? this.sidebarLinks.filter((item) => links.includes(item.to))
        : this.sidebarLinks;
    },
    roleLinks() {
      return getAvailableSitesByRole(this.userRole);
    },
  },
  watch: {
    currentPath(path) {
      localStorage.setItem("last-admin-page", path)
    },
    minimized(val) {
      localStorage.setItem("is_sidebar_minimized", val ? "true" : "");
    },
  },
};
</script>

<style>
html {
  overflow: auto;
}
</style>

<style scoped>
.icon-wrapper {
  width: 40px;
}

.group {
  transform: translate(2.5px, 2.5px);
}

@media (min-width: 993px) {
  .side-bar {
    transition-duration: 0.2s !important;
    transform: translateX(0px) !important;
    transition-property: all;
  }

  .hidingSideBar .side-bar {
    transform: translateX(-100%) !important;
  }

  .main-panel {
    width: calc(100% - 180px);
    transition-property: all;
    transition-duration: 0.2s;
  }

  .hidingSideBar .main-panel {
    width: 100% !important;
  }
}

a {
  color: white;
}

img {
  margin-right: 13px;
}

.nc-icon {
  margin-top: -8px;
}

.minimized .main-panel {
  width: calc(100% - 60px);
}

@media(max-width: 650px){
  .minimized .main-panel{
    width: 100%;
  }
}
</style>
